import {createAction} from 'util/redux';
import {DqButton, DqResponse} from 'generated/JavaTOmodifications';

const NAMESPACE = 'DqButton/'
export const fetchDqButtonsAction = createAction(NAMESPACE + 'fetch')
export const resetDqButtonsAction = createAction<DqButton[]>(NAMESPACE + 'reset')

export const dqButtonClickedAction = createAction<{ dqButton: DqButton, params?: Record<any, any> }>(NAMESPACE + 'clickedAction')
export const dqButtonLoadingAction = createAction<{ dqButton: DqButton }>(NAMESPACE + 'loading')
export const dqButtonResponseAction = createAction<{ dqButton: DqButton, result: string[], data: DqResponse }>(NAMESPACE + 'response')
export const dqButtonErrorAction = createAction<{ dqButton: DqButton, error: any }>(NAMESPACE + 'error')